require('./paymentWithDraftStep2.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { formatAmountObject, formatAmount } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');

// @ commons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @ components
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const { ConfirmationScript , CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY , CONFIRMATION_SCRIPT_AGREEMENT} = require('components/contactCenter/confirmScript/confirmationScript');

// @ constants
const { TAX_AND_RENTS_PAYMENT_WITH_DRAFT_ID } = require('constants/operationTypes');
const { DECLARATION_RESULT_TO_GIVE_BACK } = require('constants/index');


class PaymentWithDraftStep2 extends React.Component {
    render() {
        const { immTaxAndRentsPaymentWithDraft, immAccounts, immProfile, immLogin } = this.props;
        const immStep = immTaxAndRentsPaymentWithDraft.getIn(['steps', 0]);
        const clientName = immProfile.get('nombreCliente') + ' ' + immProfile.getIn(['apellidoUno', 'apellido']) + ' ' + immProfile.getIn(['apellidoDos', 'apellido']);
        const clientDocument = immLogin.get('username');
        const declarationResult = `paymentWithDraft-${immStep.get('declarationResult') === DECLARATION_RESULT_TO_GIVE_BACK ? 'toGiveBack' : 'toPay'}`;
        const immAccount = immAccounts.getIn(['byId', immStep.get('accountId')]);
        const accountBalanceAmount = immAccount.getIn(['balances', 'availableBalance']);
        const accountBalance = formatAmountObject(accountBalanceAmount).amount + ' ' + formatAmountObject(accountBalanceAmount).currencySymbol;
        const accountNumber = getLastNChars(immAccount.get('iban'), 4, '*', 4);
        const operative = formatText('operatives-paymentWithDraft');
        const hasFractionPayment = immStep.get('fractionPayment') ? 'paymentWithDraft-yes' : 'paymentWithDraft-no';
        const hasDomiciliatePayment = immStep.get('domiciliateSecondPayment') ? 'paymentWithDraft-yes' : 'paymentWithDraft-no';
        let differentialFee, otpAmount, amountToReturn, fractionPayment, firstPaymentAmount, domiciliateSecondPayment;

        if (immStep.get('declarationResult') === DECLARATION_RESULT_TO_GIVE_BACK) {
            const amount = formatAmount(immStep.get('amountToReturn')) + ' ' + formatAmountObject(accountBalanceAmount).currencySymbol;

            amountToReturn = (
                <OKInformativeListItem
                    title={formatText('paymentWithDraft-amountToReturnConfirmation')}
                    bodyText={amount}
                />
            );

            otpAmount = immStep.get('amountToReturn');
        } else {
            const amount = formatAmount(immStep.get('differentialFee')) + ' ' + formatAmountObject(accountBalanceAmount).currencySymbol;

            differentialFee = (
                <OKInformativeListItem
                    title={formatText('paymentWithDraft-differentialFeeConfirmation')}
                    bodyText={amount}
                />
            );

            otpAmount = immStep.get('differentialFee');

            fractionPayment = (
                <OKInformativeListItem
                    title={formatText('paymentWithDraft-fractionPayment')}
                    bodyText={hasFractionPayment}
                />
            );

            if (immStep.get('fractionPayment')) {
                const amount = formatAmount(immStep.get('firstPayment')) + ' ' + formatAmountObject(accountBalanceAmount).currencySymbol;

                otpAmount = immStep.get('firstPayment');

                firstPaymentAmount = (
                    <OKInformativeListItem
                        title={formatText('paymentWithDraft-firstPaymentAmount')}
                        bodyText={amount}
                    />
                );

                domiciliateSecondPayment = (
                    <OKInformativeListItem
                        title={formatText('paymentWithDraft-domiciliateSecondPayment')}
                        bodyText={hasDomiciliatePayment}
                    />
                );
            }
        }

        return (
            <article className="payment-with-draft-step-two">
                <header className="payment-with-draft-step-two__header">
                    <FormattedText
                        value="paymentWithDraft-securityConfirmation"
                        className="payment-with-draft-step-two__title"
                    />
                </header>
                
                <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY} />
                
                <section className="payment-with-draft-step-one__content">
                    <div className="row payment-with-draft-step-one__subsection">
                        <div className="col-xs-12">
                            <OKInformativeList columns={2}>
                                <OKInformativeListItem
                                    title={formatText('paymentWithDraft-name')}
                                    bodyText={clientName}
                                />
                                <OKInformativeListItem
                                    title={formatText('paymentWithDraft-document')}
                                    bodyText={clientDocument}
                                />
                                <OKInformativeListItem
                                    title={formatText('paymentWithDraft-accountNumber')}
                                    bodyText={accountNumber}
                                />
                                <OKInformativeListItem
                                    title={formatText('paymentWithDraft-balance')}
                                    bodyText={accountBalance}
                                />
                            </OKInformativeList>
                        </div>
                    </div>
                    <div className="row payment-with-draft-step-one__subsection">
                        <div className="col-xs-12">
                            <OKInformativeList columns={2}>
                                <OKInformativeListItem
                                    title={formatText('paymentWithDraft-justificative')}
                                    bodyText={immStep.get('justificative')}
                                />
                                <OKInformativeListItem
                                    title={formatText('paymentWithDraft-declarationResult')}
                                    bodyText={declarationResult}
                                />
                                {differentialFee}
                                {amountToReturn}
                                {fractionPayment}
                                {firstPaymentAmount}
                                {domiciliateSecondPayment}
                            </OKInformativeList>
                        </div>
                    </div>

                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    
                    <div className="row payment-with-draft-step-one__subsection">
                        <div className="col-xs-12">
                            <SignaturePattern
                                operationType={TAX_AND_RENTS_PAYMENT_WITH_DRAFT_ID}
                                operationParams={{
                                    originAccount: immAccount.getIn(['ibanComplex', 'codbban']),
                                    ammount: parseFloat(otpAmount),
                                    currency: accountBalanceAmount.get('currency')
                                }}
                            />
                        </div>
                    </div>
                </section>
            </article>
        )
    }
}

PaymentWithDraftStep2.propTypes = {
    immTaxAndRentsPaymentWithDraft: PropTypes.object,
    immAccounts: PropTypes.object,
    immProfile: PropTypes.object,
    immLogin: PropTypes.object,
    getTaxesAndRentsAccountDetails: PropTypes.func
};

module.exports = PaymentWithDraftStep2;
